export const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
export const CACHE = localStorage;
export const LAST_SEARCH_KEY = "gf_lastSearch";

export const API_URL = "https://api.giphy.com/v1/gifs";
export const API_PARAMS_OFFSET = 40;

